






























































import { defineComponent, ref, useStore } from '@nuxtjs/composition-api'
import { computed } from '@vue/composition-api'
import NewButton from '@/components/Inputs/new-design/NewButton.vue'
import PopupCard from '@/components/Popup/PopupCard.vue'
import Testograf from '@/components/Testograf.vue'

export default defineComponent({
  name: 'BlockFormSuccess',
  components: {
    NewButton,
    PopupCard,
    Testograf,
  },
  props: {
    phoneNumber: {
      type: [Number, String],
      required: true,
    },
    requestNumber: {
      type: [Number, String],
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    personalButtonLink: {
      type: String,
      default: '',
    },
    personalButtonText: {
      type: String,
      default: '',
    },
    mainButtonLink: {
      type: String,
      default: '',
    },
    mainButtonText: {
      type: String,
      default: '',
    },
    testografData: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const store = useStore()
    const openRateModal = ref(true)
    const modalBackground = ref(false)
    const testografMounted = ref(false)

    const isMobile = computed(() => store.getters['mediaQuery/isMobileMq'])

    const closeRateModalHandle = () => {
      openRateModal.value = false
    }

    const testografMessageHandler = ({ data }) => {
      if (
        typeof data === 'string' &&
        data?.match(/\d+:\d+:mutationObserver/g) &&
        Number(data?.match(/\d+:\d+:mutationObserver/g)[0].split(':')[0]) > 300
      ) {
        modalBackground.value = true
      }
      if (data === 'finish') {
        closeRateModalHandle()
        store.commit('notifications/SET_NOTIFICATION', {
          message: 'Спасибо за оценку!',
          variant: 'success',
          visible: true,
        })
      }
    }

    return {
      isMobile,
      openRateModal,
      modalBackground,
      testografMounted,
      testografMessageHandler,
    }
  },
})
